import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import NewDesign from 'components/NewDesign';
import BillingInfoComparison from 'components/BillingInfoComparison';

const propTypes = {};

const DialogRejectBillingInfo = ({
  isOpen,
  toggle,
  className,
  rejectReason,
  originalInfo,
  draftInfo,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={classNames('component:DialogRejectBillingInfo', className)}
      style={{ maxWidth: 600 }}
    >
      <ModalHeader toggle={toggle}>Failed reason</ModalHeader>

      <ModalBody>
        <NewDesign.Typography component='p' className='mb-2'>
          Form requested
        </NewDesign.Typography>

        <BillingInfoComparison
          className='mb-2 default-border p-2 d-flex flex-column gap-4px flex-wrap'
          originalInfo={originalInfo}
          nextInfo={draftInfo}
        />

        <NewDesign.Typography component='p' className='mb-2'>
          Reason
        </NewDesign.Typography>
        <NewDesign.Alert color='danger'>{rejectReason}</NewDesign.Alert>
      </ModalBody>

      <ModalFooter>
        <NewDesign.Button variant='text' type='button' className='btn' onClick={toggle}>
          Close
        </NewDesign.Button>
      </ModalFooter>
    </Modal>
  );
};

DialogRejectBillingInfo.propTypes = propTypes;
export default React.memo(DialogRejectBillingInfo);
